import React from 'react'
import { Card } from 'react-bootstrap'
import { i18nTranslate } from 'src/utils'
import { customerContainer } from 'src/models'

class EventStaticMyProfile extends React.Component {
  render() {
    const homeCountry = customerContainer?.getUserHomeCountry()
    return (
      <Card className="mb-3 shadow-sm">
        <Card.Body className="bg-white">
          <h1 className="event-profile-title">
            {i18nTranslate('account.profileInfo', 'Profile Information')}
          </h1>
          {homeCountry !== 'CN' && (
            <div className="event-profile-edit-info">
              {i18nTranslate(
                'event.editLocationInfo',
                'This information can be edited at '
              )}
              <a
                className="event-profile-edit-link"
                href="https://www.nuskin.com/us/en/"
                target="_blank"
                rel="noopener noreferrer">
                nuskin.com
              </a>
            </div>
          )}
          {this.props.data &&
            this.props.data.map(field => (
              <div className="event-profile-field">
                <div className="event-profile-field-name">
                  {i18nTranslate(field.label, 'Profile Information')}
                </div>
                <div className="event-profile-field-value">{field.value}</div>
              </div>
            ))}
        </Card.Body>
      </Card>
    )
  }
}

export default EventStaticMyProfile
